
import t from "prop-types";
import { CircularProgress, Tooltip } from "@material-ui/core";
import { Button } from "juno-shared-components";

const propTypes = {
  isLoading: t.bool,
  disabled: t.bool,
  // children: t.oneOfType([t.string, t.element, t.object]),
  tooltipTxt: t.oneOfType([t.string, t.object]),
  color: t.string,
  variant: t.string,
  size: t.string,
  tooltipEnterDelay: t.number,
  startIcon: t.oneOfType([t.string, t.element]),
};

const CommonButton = props => {
  const { isLoading, disabled, children, tooltipTxt, color, variant, size, tooltipEnterDelay, startIcon, ...otherProps } = props;
  const newProps = {
    ...otherProps,
    variant: color === "secondary" ? "outlined" : (variant || "contained") || "contained",
    color: color === "secondary" ? "primary" : (color || "primary") || "primary",
    size,
  };
  const calcButtonSize = () => {
    switch (size) {
      case "small":
        return "25px";
      case "medium":
        return "27px";
      case "large":
        return "28px";
      default:
        return "25px";
    }
  };

      
  const Btn = (
    <Button
      {...newProps}
      startIcon={!isLoading ? startIcon : undefined}
      disabled={isLoading || disabled}
    >{!isLoading ? children : <CircularProgress size={calcButtonSize()} />}
    </Button>
  );

  if (!tooltipTxt) {
    return Btn;
  }

  return (
    <Tooltip
      title={tooltipTxt || ""}
      enterDelay={tooltipEnterDelay || 500}
      enterNextDelay={tooltipEnterDelay || 500}
      placement={otherProps?.placement}
    >
      <span>{Btn}</span>
    </Tooltip>
  );
};

CommonButton.propTypes = propTypes;

export default CommonButton;
